import React from "react";

function DashboardPage() {
  return <div className="countdown">We will activate the Holder Dashboard shortly after the mint.</div>;
}

export default DashboardPage;
